import CurrencyInput from "react-currency-input-field";
import "./../../assets/scss/scoped/currency-input.scoped.scss";

export default function CurrencyCustomInput({
  // className,
  isInvalid,
  currencySymbol = "₦",
  rounded = "",
  ...props
}) {
  return (
    <div
      className={`currency-input  ${rounded} ${
        isInvalid ? "border-danger shadow-none" : ""
      }`}
    >
      <span className="currency text-nowrap">{currencySymbol}</span>
      <CurrencyInput
        placeholder="0.00"
        {...props}
        decimalScale={2}
        onClick={(e) => e.target.select()}
      />
    </div>
  );
}
